module.exports = __webpack_public_path__ + "static/media/Ad_NCA.5c6cea86.jpg";